import { Avatar, Box, IconButton, Menu, MenuItem } from '@mui/material';
import { useStytchB2BClient, useStytchMember } from '@stytch/react/b2b';
import { usePostHog } from 'posthog-js/react';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFirebaseCustomAuth } from '../firebase';

export default function AppAvatar() {
    const stytch = useStytchB2BClient();
    const posthog = usePostHog();
    const { member } = useStytchMember();
    const navigate = useNavigate();

    const { logout: firebaseLogout } = useFirebaseCustomAuth();

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const logout = async () => {
        await firebaseLogout();
        await stytch.session.revoke();
        posthog.reset();
    };

    const nav = () => {
        handleClose();
        navigate('/organization');
    }

    if (!member) return null;

    return (
        <>
            <Box sx={{ flexGrow: 0 }}>
                <IconButton sx={{ p: 0 }} onClick={handleClick}>
                    <Avatar alt={member.name} />
                </IconButton>
            </Box>
            <Menu
                id="user-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'user-menu',
                }}
            >
                <MenuItem onClick={nav}>My Organization</MenuItem>
                <MenuItem onClick={logout}>Logout</MenuItem>
            </Menu>
        </>
    );
}